exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content[data-v-656786f2]{padding-top:56px}", ""]);

// exports
